  // CUSTOM JS FOR CHARACTER LIMIT ON EMBROIDERY INPUT 

const embroideryInput = () => document.querySelector('.gdc-embroidery-js');

function updateEmbroideryCharCount() {
  const charCount = embroideryInput().value.length;
  const max = embroideryInput().getAttribute('maxlength')
  const charsRemaining = max - charCount;
  const counter = document.querySelector('#gdc-embroidery-char-counter')
  const newNum = document.createTextNode(`${charsRemaining}`)

  counter.removeChild(counter.firstChild)
  counter.appendChild(newNum);
}

function updateButtonText() {
    const button = document.querySelector('.gdc-embroidery__dropdown-button')
    button.innerHTML = embroideryInput().value
} 

function handleEmbroideryInput() {
  updateEmbroideryCharCount()
  updateButtonText()
} 

window.onload = function() {
  updateEmbroideryCharCount();
}

// EMBROIDERY DROPDOWN

const getDropdown = () => document.querySelector('.gdc-embroidery__dropdown')

function closeMenu() {
  getDropdown().classList.add('hide-embroidery-dropdown')
  window.removeEventListener('click', handleCloseOutsideMenu)
}

function handleCloseOutsideMenu(e) {
  const insideMenu = e.target.closest('.gdc-embroidery__field-wrapper')

    if (!insideMenu) { 
      closeMenu()
    }
}

function handleDropdown() {
  getDropdown().classList.toggle('hide-embroidery-dropdown')
  window.addEventListener('click', handleCloseOutsideMenu)
}

function handleDropdownItems() {
  const items = document.querySelectorAll('.gdc-embroidery__preselect-item')
  
  function handleItemClick(e) {
    const text = e.target.innerHTML
    embroideryInput().setAttribute('value', text)
    embroideryInput().value = text
    updateButtonText()
    updateEmbroideryCharCount()
  }

  items.forEach(item => {
    item.addEventListener('click', handleItemClick)
  })
}

window.addEventListener('load', handleDropdownItems)